import { ChangeDetectionStrategy, Component, computed, input, output, signal } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatChipListbox, MatChipListboxChange, MatChipOption } from '@angular/material/chips';
import { AskQuestion } from './questions-display.types';

@Component({
  selector: 'ai-assistant-questions-display',

  imports: [MatButtonModule, MatChipListbox, MatChipOption],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './questions-display.component.html',
  styleUrls: ['./questions-display.component.scss'],
})
export class QuestionsDisplayComponent {
  readonly questions = input.required<AskQuestion[]>();
  readonly outputText = input<string>('');
  readonly answered = output<Record<string, string>>();
  readonly cancelled = output<void>();

  readonly answers = signal<Record<string, string>>({});

  readonly allAnswered = computed(() => {
    const sels = this.answers();
    return this.questions().every((q) => !!sels[q.id]);
  });

  onChipChange(id: string, event: MatChipListboxChange): void {
    this.setAnswer(id, event.value);
  }

  onChoiceChange(id: string, value: string): void {
    this.setAnswer(id, value);
  }

  private setAnswer(id: string, value: string | undefined): void {
    this.answers.update((s) => {
      const updated = { ...s };
      if (value !== undefined) {
        updated[id] = value;
      } else {
        delete updated[id];
      }
      return updated;
    });
  }

  isSelected(id: string, option: string): boolean {
    return this.answers()[id] === option;
  }

  getTextValue(id: string): string {
    const value = this.answers()[id];
    return value === 'Skip' ? '' : value || '';
  }

  onTextInput(id: string, event: Event): void {
    const input = event.target as HTMLInputElement;
    this.answers.update((s) => {
      const updated = { ...s };
      if (input.value) {
        updated[id] = input.value;
      } else {
        delete updated[id];
      }
      return updated;
    });
  }

  onContinue(): void {
    this.answered.emit(this.answers());
  }

  onCancel(): void {
    this.cancelled.emit();
  }
}
